interface Props {
    border_top?: string
    border_colour?: string
    margin_x?: string
  }
  
  export default function Spinner({
    border_top = 'border-t-white',
    border_colour = 'border-[#7F56D9]',
    margin_x = 'mx-auto'
  }: Props) {
    return (
      <div
        className={`w-4 h-4 border-4 ${border_top} ${border_colour} rounded-full animate-spin ${margin_x} my-auto`}
      />
    )
  }